import { EntitiesState } from '@redux/entities'

import type { CampaignModel, CampaignQuoteTemplateItemModel } from '@models/types'

type BuildProviderPackageOrderParams = {
  agencyId?: number,
  campaignId: number,
  campaignQuoteId?: number,
  campaignQuoteTemplateId?: number,
  isDefaultQuoteItem?: boolean,
  providerPackageId: number,
  providerPackages: EntitiesState['providerPackages'],
  quoteSectionId?: number,
  redirect?: string,
}

const buildProviderPackageOrder = (params: BuildProviderPackageOrderParams) => {
  const {
    agencyId,
    campaignId,
    campaignQuoteId,
    campaignQuoteTemplateId,
    isDefaultQuoteItem,
    providerPackageId,
    providerPackages,
    quoteSectionId,
    redirect,
  } = params

  const providerPackage = providerPackages[providerPackageId]

  // Quote Item or Quote Template Item (note: entities use package_id, not provider_package_id)
  if (campaignQuoteId || campaignQuoteTemplateId){
    const payload: Partial<CampaignQuoteTemplateItemModel> = {
      // @ts-expect-error TS2353
      campaign_quote_id: undefined,
      campaign_quote_section_id: undefined,
      campaign_quote_template_id: undefined,
      campaign_quote_template_section_id: undefined,
      item_type: 'orderable',
      package_id: providerPackage.id,
      title: providerPackage.title,
    }

    // Quote
    if (campaignQuoteId){
      // @ts-expect-error TS2339
      payload.campaign_quote_id = campaignQuoteId
      // @ts-expect-error TS2339
      payload.campaign_quote_section_id = quoteSectionId
    }

    // Quote Template
    if (campaignQuoteTemplateId){
      payload.campaign_quote_template_id = campaignQuoteTemplateId
      payload.campaign_quote_template_section_id = quoteSectionId
    }

    return {
      itemType: campaignQuoteTemplateId ? 'quoteTemplateItem' : 'quoteItem',
      payload,
      redirect,
    }
  }

  // Default Quote Items have provider_package_id instead of package_id
  if (isDefaultQuoteItem){
    return {
      itemType: 'defaultQuoteItem',
      payload: {
        owner_id: agencyId,
        owner_type: 'Agency',
        provider_package_id: providerPackage.id,
        item_type: 'orderable',
        title: providerPackage.title,
      },
      redirect,
    }
  }

  // Order
  return {
    itemType: 'order',
    payload: {
      campaign_id: campaignId,
      order_type: 'package',
      provider_package_id: providerPackage.id,
    },
    redirect,
  }
}

export type BuildProviderPackageOrderPayload = ReturnType<typeof buildProviderPackageOrder>

export default buildProviderPackageOrder
